import React from 'react';
import { Field } from 'redux-form';

import { Col, ControlLabel, Row } from 'react-bootstrap';
import { HorizontalFormControl, PublicCheckbox } from '../../../../common/components';
import TextArea from '../../../content/components/TextArea/TextArea';
import {
  WhiteLabelContentContainer
} from '../WLContentContainer/WhiteLabelContentContainer';

const WhiteLabelContent = ({ show }) => {
  if (!show) {
    return null;
  }

  return (

    <WhiteLabelContentContainer title={'White label content'}>
      <>
        <Row>
          <Col sm={12}>
            <Field
              name="meta.whitelabel.content.display_name"
              label="Display Name"
              component={HorizontalFormControl}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <Field
              name="meta.whitelabel.content.telephone_number"
              label="Telephone Number"
              component={HorizontalFormControl}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <Field
              name="meta.whitelabel.content.opening_hours"
              label="Opening Hours"
              component={HorizontalFormControl}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <Field
              name="meta.whitelabel.content.strap_line"
              label="Strap Line"
              component={HorizontalFormControl}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <ControlLabel>Home Page Content</ControlLabel>
          </Col>
          <Col sm={12}>
            <Field
              name="meta.whitelabel.content.homepage_content"
              component={TextArea}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <ControlLabel>Footer</ControlLabel>
          </Col>
          <Col sm={12}>
            <Field name="meta.whitelabel.content.footer" component={TextArea}/>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <Field
              name="meta.whitelabel.content.meta_title"
              label="Meta Title"
              component={HorizontalFormControl}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <Field
              name="meta.whitelabel.content.meta_description"
              label="Meta Description"
              component={HorizontalFormControl}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <Field
              name="meta.whitelabel.content.meta_robots_enabled"
              label="SEO Indexing Enabled"
              component={PublicCheckbox}
            />
          </Col>
        </Row>
      </>
    </WhiteLabelContentContainer>

  );
};

export default WhiteLabelContent;
